import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M6.572 18.057 18.058 6.57M17.729 17.729 6.243 6.243"
    />
  </svg>
);
export const CloseIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
